import React from "react";
import { useForm } from "react-hook-form";
import { Link } from 'react-router-dom';

import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';

import * as ValidationMessages from '../constants/ValidationMessages';
import * as DataPattern from '../constants/DataPattern';



export const LoginForm = (props) => {
    const { register, handleSubmit, reset, formState: { errors } } = useForm();

    const [showPassword, setShowPassword] = React.useState(false);

    const handleClickShowPassword = () => setShowPassword(!showPassword);

    const handleSubmitLogin = (data) => {

        var authenticationData = {
          Username : data.username,
          Password : data.password
        };
    
        console.log('> login user: ' + JSON.stringify(authenticationData.Username));
        props.loginUser(authenticationData, props.onLoginCallback);
      }

      var errMsg = null;
      if(props.auth.errMess) {
        //"PasswordResetRequiredException"
        if(props.auth.errMess.code === "NotAuthorizedException") {
            errMsg = ValidationMessages.INVALID_USER_OR_PASSWORD;
        }
        else {
            errMsg = props.auth.errMess.message;
        }
      }
    
    return (
        <Container maxWidth="xl">
        <Box px={{xs: 3, sm: 7}}>

            <Grid container justify="center" alignItems="center" direction="column" minHeight={{minHeight: "50vh"}} pt={{xs: 5, sm: 5}} spacind={5}>
                <Grid item style={{ border: "0.2px solid gray", width: "500px"}} sx={{px: 2, py: 2}}>

                    <form id='loginForm' onSubmit={handleSubmit(handleSubmitLogin)}>
                    <Grid container  justify="center" alignItems="center" direction="column">

                        <Box textAlign="center"
                            sx={{width: "100%", height: 70,}}
                        > 
                            <Typography variant="h5">Login Utilizator</Typography>
                            <Divider sx={{ borderBottomWidth: 1, borderColor: "black", mt: 1 }} />
                        </Box>

                        {!errMsg ?
                            <React.Fragment></React.Fragment>
                                :
                            <Typography
                                component="div"
                                color="error"
                                sx={{ flexGrow: 1, mr: 1 }}
                            >
                                {errMsg}
                            </Typography>
                        }

                        <TextField variant="standard" size="small" label="Nume Utilizator" fullWidth margin="dense"
                            {...register("username", { required: ValidationMessages.REQUITED_MESSAGE })}
                            error={!!errors?.username}
                            helperText={errors?.username ? errors.username.message : null}
                        />

                        <TextField variant="standard" size="small" label="Parola" fullWidth margin="dense" 
                            type={showPassword ? "text" : "password"} 
                            autoComplete='off'
                            InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton
                                        onClick={handleClickShowPassword}
                                    >
                                        {!showPassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
                                    </IconButton>
                                </InputAdornment>
                            )
                            }}

                            {...register("password", { required: ValidationMessages.REQUITED_MESSAGE })}
                            error={!!errors?.password}
                            helperText={errors?.password ? errors.password.message : null}
                        />

                        <Button variant="outlined" type='submit' sx={{width: 200, margin: 3}} disabled={props.auth.isLoading}>
                            {props.auth.isLoading && <CircularProgress size={25} />}
                            {!props.auth.isLoading && 'Login'}
                        </Button>

                        <Box sx={{ width: '100%', marginTop: 2 }} textAlign="right">
                            <Link to="/password-reset" style={{ textDecoration: 'none' }}>Ati uitat Parola?</Link>
                        </Box>

                    </Grid>
                    </form>

                </Grid>
            </Grid>

        </Box>
        </Container>
    );
};


export const ChangePasswordChallengeForm = (props) => {
    const { register, handleSubmit, getValues, formState: { errors } } = useForm({
        defaultValues: {
            username: props.auth.cognitoState.username
        } 
    });

    const [showPassword, setShowPassword] = React.useState(false);
    const [showPasswordConf, setShowPasswordConf] = React.useState(false);

    const handleClickShowPassword = () => setShowPassword(!showPassword);
    const handleClickShowPasswordConf = () => setShowPasswordConf(!showPasswordConf);

    const handleChangePassword = (data) => {

        var authenticationData = {
          Username : data.username,
          Password : data.password
        };
    
        props.changePasswordChallenge(authenticationData);
      }

      const errMsg = null;
    

      const validatePasswordMatch = (passwordConf) => {
        const password = getValues('password');
        if(password && password !== passwordConf) {
            return ValidationMessages.PWD_AND_PWD_CONF_MISMATCH;
        }
        else {
            return true;
        }
    }

    return (
        <Container maxWidth="xl">
        <Box px={{xs: 3, sm: 7}}>

            <Grid container justify="center" alignItems="center" direction="column" minHeight={{minHeight: "50vh"}} pt={{xs: 5, sm: 5}} spacind={5}>
                <Grid item style={{ border: "0.2px solid gray", width: "500px"}} sx={{px: 2, py: 2}}>

                    <form id='loginForm' onSubmit={handleSubmit(handleChangePassword)}>
                    <Grid container  justify="center" alignItems="center" direction="column">

                        <Box textAlign="center"
                            sx={{width: "100%", height: 70,}}
                        > 
                            <Typography variant="h5">Schimba Parola</Typography>
                            <Divider sx={{ borderBottomWidth: 1, borderColor: "black", mt: 1 }} />
                        </Box>

                        {!errMsg ?
                            <React.Fragment></React.Fragment>
                                :
                            <Typography
                                component="div"
                                color="error"
                                sx={{ flexGrow: 1, mr: 1 }}
                            >
                                {errMsg}
                            </Typography>
                        }

                        <TextField variant="standard" size="small" label="Nume Utilizator" fullWidth margin="dense" disabled
                            {...register("username", { required: ValidationMessages.REQUITED_MESSAGE })}
                            error={!!errors?.username}
                            helperText={errors?.username ? errors.username.message : null}
                        />

                        <TextField variant="standard" size="small" label="Parola" fullWidth margin="dense"
                            type={showPassword ? "text" : "password"} 
                            autoComplete='off'
                            InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton
                                        onClick={handleClickShowPassword}
                                    >
                                        {!showPassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
                                    </IconButton>
                                </InputAdornment>
                            )
                            }}

                            {...register("password", 
                                {required: ValidationMessages.REQUITED_MESSAGE,
                                pattern: {
                                    value: DataPattern.PATTERN_COGNITO_PASSWORD,
                                    message: ValidationMessages.INVALID_COGNITO_PASSWORD_FORMAT,
                                }  
                                }
                            )} 
                            error={!!errors?.password}
                            helperText={errors?.password ? errors.password.message : null}
                        />

                        <TextField variant="standard" size="small" label="Confirmare Parola" fullWidth margin="dense"
                            type={showPasswordConf ? "text" : "password"} 
                            autoComplete='off'
                            InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton
                                        onClick={handleClickShowPasswordConf}
                                    >
                                        {!showPasswordConf ? <VisibilityIcon /> : <VisibilityOffIcon />}
                                    </IconButton>
                                </InputAdornment>
                            )
                            }}

                            {...register("passwordConf", 
                                {required: ValidationMessages.REQUITED_MESSAGE,
                                pattern: {
                                    value: DataPattern.PATTERN_COGNITO_PASSWORD,
                                    message: ValidationMessages.INVALID_COGNITO_PASSWORD_FORMAT
                                },  
                                validate: validatePasswordMatch
                            }
                            )} 
                            error={!!errors?.passwordConf}
                            helperText={errors?.passwordConf ? errors.passwordConf.message : null}
                        />

                        <Button variant="outlined" type='submit' sx={{width: 200, margin: 3}}>Schimba Parola</Button>

                    </Grid>
                    </form>

                </Grid>
            </Grid>

        </Box>
        </Container>
    );
}
